import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from "../../environments/environment";
import { BBResponseContainer } from '../common-services/response-container';
import { timeout, tap ,map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Covid19Batch,WellType } from '../agptesting-newview/model/covid19Batch';
@Injectable()
export class MidplexSamplesService {
  defaultTimeout = 600000;
  
  constructor(private http: HttpClient) {
  }
  
  getMidplexBatchesForLab(labId: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19MidplexBatch/list";
    let requestParam = new HttpParams().set('lab', labId);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }
  
  saveSampleMidplexData(batch: Covid19Batch): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19MidplexBatch";
    return this.http.post<BBResponseContainer>(url, batch).pipe(timeout(environment.defaultTimeout), tap(event => error => {
      error.url = url;
    }));
  }

  getSourceBatchSamples(selectedLabId: string, sourceBatchIds: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/midplexTagBatchesForMerge/" + selectedLabId + '/' + sourceBatchIds;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }
  
  assignTagPlateBarcodes(selectedBatch: Covid19Batch) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19MidplexBatch/assignTagPlateToSamples";
    return this.http.put<BBResponseContainer>(url, selectedBatch).pipe(timeout(environment.defaultTimeout), tap(event => error => {
      error.url = url;
    }));
  }

  filterMidplexBatchesForSamplesMenu(selectedStates: string, selectedLabId: string, fromDate: string, toDate: string): Observable<BBResponseContainer> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19MidplexBatch/filter";
    let requestParam = new HttpParams().set('selectedStatusList', selectedStates).set('labId', selectedLabId).set('fromDate', fromDate).set('toDate', toDate);
    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  getMidPlexBatchHistory(lab: string, batchID: string, wellType: WellType) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19MidplexBatch/history/" + lab + "/" + batchID + "/" + wellType;
    return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout));
  }

  uploadCSVFile(formData: FormData) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "api/excel/upload";
    return this.http.post<any>(url, formData).pipe(timeout(this.defaultTimeout), tap( error => {
      error.url = url;
    }));
  }
  getTagSortingFileData(formData: FormData) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'api/excel/upload' ;
    return this.http.post<any>(url, formData).pipe(timeout(this.defaultTimeout), tap( error => {
      error.url = url;
    }))
  }
  
  downloadTagSortFile(downloadType:string, jsonString: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'api/excel/download' ;
    let requestParam = new HttpParams().set('downloadType', downloadType).set('requestParam', jsonString);
    return this.http.get(url, { observe: 'response', responseType: 'blob', params: requestParam}).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
      })
      );
    }

  redoBatch(selectedBatch: Covid19Batch) {
     let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19MidplexBatch/redo";
    return this.http.put<any>(url, selectedBatch).pipe(timeout(environment.defaultTimeout));
  }
  getSourceBatchComments(selectedLabId: string, sourceBatchIds: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/midplexComments/" + selectedLabId + '/' + sourceBatchIds;
    return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
  }

  createPoolIdForTheBatch(covid19Batch: Covid19Batch): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/generatePoolIdForMidplex";
    return this.http.put<any>(url, covid19Batch).pipe(timeout(this.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }
}
